// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"0ffa8ac8f15c392ae3ba","581":"7c997e320f58d1a12736"}[chunkId] + ".js";
};